export abstract class HyperDropComponent {

  elements: object

  constructor(options?) {
    // if (typeof element == 'string') {
    //   this.rootElement = document.querySelector(element)
    // } else {
    //   this.rootElement = element;
    // }

    if(options.elements){
      this.elements = options.elements
    }
    this.onMount(options);
  }
  emit(source: HTMLElement, eventName: string, detail: any = {}) {
    const event = new CustomEvent(eventName, { detail });
    source.dispatchEvent(event);
  }
  abstract onMount(options): void;
}
